import { loadShared } from './dashboardCache';

// Project Dues = what is late, and what is about to be, in InteTasks (the project tool). The server side is
// project_dues_dashboard.controller.js; the counting rules are in warningDashboard/projectDues.js there.

export const PROJECT_DUES_URL = 'warning-dashboard/project-dues-dashboard';

// What a click on a number opens: the tasks behind it. One place builds the URL, so the page that PREFETCHES on hover and the popup
// that LOADS on click share the very same remembered answer (dashboardCache.js).
export const projectDuesTasksUrl = ({ kind, projectId = null, userId = null }) => {
  const params = new URLSearchParams({ kind });
  if (projectId !== null && projectId !== undefined) params.set('projectId', String(projectId));
  if (userId !== null && userId !== undefined) params.set('userId', String(userId));
  return `warning-dashboard/project-dues-tasks?${params.toString()}`;
};

export const prefetchProjectDuesTasks = (request) => {
  loadShared(projectDuesTasksUrl(request)).catch(() => {});
};

export const KIND_TITLE = {
  overdue: 'Overdue tasks',
  due_today: 'Due today',
  due_soon: 'Due in the next 7 days',
  open: 'Open tasks',
  done: 'Completed tasks',
  no_due_date: 'Tasks with no due date',
  unassigned: 'Tasks nobody is assigned to',
};

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// "3 days late" / "Late today" / "Due today" / "Due in 2 days" / "No due date" / "Done" - one phrase for a task row
export const dueText = (row) => {
  if (row.isDone) return 'Done';
  if (row.daysLate !== null && row.daysLate !== undefined) return row.daysLate === 0 ? 'Late today' : `${plural(row.daysLate, 'day', 'days')} late`;
  if (row.daysLeft !== null && row.daysLeft !== undefined) return row.daysLeft === 0 ? 'Due today' : `Due in ${plural(row.daysLeft, 'day', 'days')}`;
  return 'No due date';
};

// "12:30" from "12:30:00"; nothing when no time was set
export const shortTime = (t) => (t ? String(t).slice(0, 5) : '');

// how long a project is late: "5 days late"
export const projectLateText = (project) => (project.isOverdue ? `${plural(project.daysLate, 'day', 'days')} late` : '');

// "62.5%" or "-" when there is nothing to divide
export const percentText = (v) => (v === null || v === undefined ? '-' : `${v}%`);

// "Task: title" / "Project: name" for a waiting date-change request
export const requestSubject = (r) => (r.kind === 'task' ? r.taskTitle : r.projectName) || '-';

export const requestDates = (r) => `${r.fromDue || 'no date'} → ${r.toDue || 'no date'}`;
